const R = require('ramda');

const configurations = {
	_: {
		color: '00002',
		instrumentCount: 5,
		instruments: ['instrument-01', null, null, null, null],
		instrumentTips: [],
		physicianTableAccessories: [],
		assistantTableAccessories: [null, null, null, null, null],
		assistantTableType: 'at-type-01',
		hoseOrientation: 'up',
		chair: 'sk1-01',
		chairAccessories: ['sk1-01-ca-01', 'sk1-01-ca-03'],
		footControl: 'fcr17',
		lamp: 'lamp-01',
		lampOptions: [],
		monitor: null,
		monitorOption: null,
		lampMastAccessory: 'lma-blank',
		lampMastAccessoriesAdditionalOptions: [],
		suctionSystem: 'suction-system-01',
		waterSupplies: ['water-supply-01'],
		extraColorOption: null,
		addons: [],
		hoseDeliverySystems: [],
		discount: 0,
		physicianChairs: [],
	},
	'chirana-easy': {
		assistantTableType: 'at-type-03',
		physicianTableAccessories: ['pta-02', 'pta-04'],
		instruments: [
			'instrument-01',
			'instrument-10',
			'instrument-08',
			'instrument-14',
			'instrument-24',
		],
		suctionSystem: 'suction-system-04',
		assistantTableAccessories: ['ata-21', 'ata-22', null, null, null],
	},
	'chirana-effective': {
		assistantTableType: 'at-type-03',
		instrumentCount: 6,
		instruments: [
			'instrument-01',
			'instrument-12',
			'instrument-08',
			'instrument-19',
			'instrument-23',
			null,
		],
		suctionSystem: 'suction-system-04',
		lamp: 'lamp-02',
		chair: 'sk1-08',
		chairAccessories: ['sk1-08-ca-02', 'sk1-08-ca-04'],
		assistantTableAccessories: ['ata-21', 'ata-22', null, null, null],
	},
	'chirana-l': {
		assistantTableType: 'at-type-02',
		physicianTableAccessories: ['pta-04'],
		instruments: [
			'instrument-01',
			'instrument-10',
			'instrument-09',
			'instrument-14',
			'instrument-24',
		],
		suctionSystem: 'suction-system-04',
		lamp: 'lamp-02',
		assistantTableAccessories: ['ata-21', 'ata-22', null, null, null],
	},
	'chirana-uni': {
		hoseOrientation: 'down',
		instruments: [
			'instrument-01',
			'instrument-09',
			'instrument-08',
			'instrument-15',
			'instrument-25',
		],
		lamp: 'lamp-02',
		assistantTableAccessories: [null, null, null, null, null],
	},
	'smile-mini-04': {
		instrumentCount: 4,
		instruments: ['instrument-01', 'instrument-09', 'instrument-07', 'instrument-16'],
		physicianTableAccessories: ['pta-01'],
		assistantTableType: null,
		lamp: null,
		monitor: null,
		footControl: 'foot-control',
		lampMastAccessory: null,
		chairAccessories: [],
	},
};

export const getDefaultConfigurationOf = unitName =>
	configurations[unitName] ? R.clone(configurations[unitName]) : {};
